var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._l((_vm.selectModel(_vm.modelValue, _vm.dataSelectorKey)),function(item,index){return _c('v-chip',{key:index,staticClass:"mx-1",attrs:{"outlined":"","small":"","color":_vm.textColor(item)}},[_c('strong',[_vm._v(" "+_vm._s(_vm._f("toINR")(item[_vm.itemDataSelectorKey]))+" ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }